import { Formik } from 'formik';
import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import Switch from 'react-switch';
import * as Yup from 'yup';
import { confirmAlert } from 'react-confirm-alert';

import DateTimePicker from '../../components/Inputs/DateTimePicker';
import FileInput from '../../components/Inputs/FileInput';
import FormInput from '../../components/Inputs/FormInput';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import CadastroPedidoModal from '../../components/Modals/CadastroPedidoModal';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import {
  hasClienteComPA,
  isAdmin,
  isAdminBio,
  isAprovador,
  isSolicitante,
  isSudo,
} from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { defaultService } from '../../services/defaultService';
import { pedidosService } from '../../services/pedidos.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { produtoService } from '../../services/produto.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import AuditLogModal from './AuditLogModal';
import SelectInput from '../../components/Inputs/SelectInput';
import CpfInput from '../../components/Inputs/CpfInput';
import { isValidCPF } from '../../components/Utils/cpfUtils';

const getPedidoValidationSchema = () => {
  return Yup.object().shape({
    itens: Yup.array().of(
      Yup.object().shape({
        produto: Yup.object()
          .nullable()
          .required('Obrigatório')
          .test('produto-valido', 'Obrigatório', (produto) => {
            return !!(
              produto &&
              (produto.id || produto.codigoProduto || produto.codigoOmni)
            );
          }),
      }),
    ),
    pontoAtendimentoId: Yup.string().when('cliente', {
      is: (cliente) => cliente && cliente.possuiPontoAtendimento === true,
      then: (s) => s.required('Obrigatório'),
      otherwise: (s) => s.nullable(),
    }),
    dataHoraColeta: Yup.date().when('cliente', {
      is: (cliente) => !cliente || !cliente.possuiPontoAtendimento,
      then: Yup.date().required('Obrigatório'),
      otherwise: Yup.date().nullable(),
    }),
    nomePaciente: Yup.string().when('grupoPedido', {
      is: (val) => val === 'JUDICIAL' || val === 'DOMICILIAR',
      then: Yup.string().required('Obrigatório'),
      otherwise: Yup.string().nullable(),
    }),
    cpfPaciente: Yup.string()
      .nullable()
      .transform((v) => (v ? String(v).replace(/\D/g, '') : v))
      .when(['grupoPedido', 'cliente'], {
        is: (grupoPedido, cliente) =>
          (grupoPedido === 'JUDICIAL' || grupoPedido === 'DOMICILIAR') &&
          cliente &&
          cliente.possuiPontoAtendimento === true,
        then: (s) =>
          s
            .required('Obrigatório')
            .test('cpf-valido', 'CPF inválido', (value) => {
              if (!value) return false;
              return isValidCPF(value);
            }),
        otherwise: (s) => s.notRequired().nullable(),
      }),
    tipoPedido: Yup.string().required('Tipo de pedido é obrigatório'),
    grupoPedido: Yup.string()
      .nullable()
      .when('cliente', {
        is: (cliente) => cliente && cliente.possuiPontoAtendimento === true,
        then: (s) => s.required('Grupo do pedido é obrigatório'),
        otherwise: (s) => s.nullable(),
      }),
  });
};

class PedidoEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = {
      entity: {},
      viewMode: false,
      index: null,
      quantidadesAjusteOmie: {},
      salvandoAjusteOmie: {},
    };
    this.submittingRef = { current: false };
    this.handleSubmitPedido = this.handleSubmitPedido.bind(this);
  }

  isTipoPedidoEmMapa = (tipoPedido) => {
    return tipoPedido === 'MAPA';
  };

  normalizarGrupoPedidoLegado = (pedido) => {
    const pedidoNormalizado = _.cloneDeep(pedido || {});

    const clienteTemPA =
      pedidoNormalizado &&
      pedidoNormalizado.cliente &&
      pedidoNormalizado.cliente.possuiPontoAtendimento === true;

    if (!clienteTemPA) {
      delete pedidoNormalizado.grupoPedido;
      return pedidoNormalizado;
    }

    return pedidoNormalizado;
  };

  handleSubmitPedido = (values, actions) => {
    let pedidoEntity = this.normalizarGrupoPedidoLegado(values);

    const clienteTemPA =
      pedidoEntity &&
      pedidoEntity.cliente &&
      pedidoEntity.cliente.possuiPontoAtendimento === true;

    if (clienteTemPA) {
      const tipoPedidoEmMapa = this.isTipoPedidoEmMapa(pedidoEntity.tipoPedido);

      if (!pedidoEntity.grupoPedido) {
        pedidoEntity.grupoPedido = tipoPedidoEmMapa
          ? 'ALMOXARIFADO'
          : 'DOMICILIAR';
      }
    } else {
      delete pedidoEntity.grupoPedido;
    }

    if (_.get(pedidoEntity, '_links.self.href')) {
      _.set(
        pedidoEntity,
        'id',
        defaultService.getIdFromUrl(_.get(pedidoEntity, '_links.self.href')),
      );
    }

    let produtos = [];

    _.map(pedidoEntity.itens, (i) => {
      if (!i || !i.produto || !i.produto.estoque) return;

      _.map(i.produto.estoque, (estoque) => {
        if (estoque && estoque.quantidade && estoque.quantidade > 0) {
          let produto = _.cloneDeep(i);
          produto.quantidade = estoque.quantidade;

          if (clienteTemPA) {
            delete produto.observacoes;
            delete produto.dataValidade;
          } else {
            produto.observacoes = estoque.observacoes;
            produto.dataValidade = estoque.dataDeValidade;
          }

          if (produto && produto.produto) {
            produto.produto.estoque = null;
          }
          produtos.push(produto);
        }
      });
    });

    pedidoEntity.itens = produtos;
    this.props.loading(true);

    // Alteracao de itens precisa passar pela API que sincroniza as reservas.
    // O endpoint generico /pedidos grava direto no repositorio e nao calcula
    // diferencas de quantidade para o estoque interno.
    const saveMethod = pedidosService.criar;

    const isNovoPedido = !pedidoEntity.id;

    if (isSolicitante() || ((isAdmin() || isAprovador()) && isNovoPedido)) {
      pedidoEntity.statusInterno = 'CRIADO';
    }

    saveMethod(pedidoEntity)
      .then((response) => {
        let id;
        if (response.data._links && response.data._links.self) {
          id = defaultService.getIdFromUrl(response.data._links.self.href);
        } else if (response.data.id) {
          id = response.data.id;
        }

        values.id = id;
        this.props.history.push('/pedidos');
        this.props.success({
          message:
            'Pedido salvo com sucesso: ' + response.data.numeroPedido + '.',
        });
      })
      .catch((e) => {
        console.log(e);
        let message = _.get(e, 'response.data');

        if (message && typeof message !== 'string') {
          message =
            _.get(message, 'message') ||
            _.get(message, 'error') ||
            'Erro ao salvar o pedido.';
        }

        this.props.error({
          message: message || 'Erro ao salvar o pedido.',
        });
      })
      .finally(() => {
        actions.setSubmitting(false);
        this.props.loading(false);
      });
  };

  componentDidMount() {
    this.carregarPedidoAtualDaRota(this.props);
  }

  componentDidUpdate(prevProps) {
    const idAnterior = _.get(prevProps, 'match.params.id');
    const idAtual = _.get(this.props, 'match.params.id');
    const copiarDeIdAnterior = _.get(prevProps, 'location.state.copiarDeId');
    const copiarDeIdAtual = _.get(this.props, 'location.state.copiarDeId');

    if (idAnterior !== idAtual || copiarDeIdAnterior !== copiarDeIdAtual) {
      this.carregarPedidoAtualDaRota(this.props);
    }
  }

  carregarPedidoAtualDaRota = (props) => {
    const id = _.get(props, 'match.params.id');
    const copiarDeId = _.get(props, 'location.state.copiarDeId');

    if (copiarDeId) {
      this.carregarPedidoParaFormulario(copiarDeId, true);
      return;
    }

    if (id) {
      this.carregarPedidoParaFormulario(id, false);
    } else {
      this.setState({
        entity: {
          cliente: props.user.cliente,
          tipoPedido: 'AVULSO',
          statusInterno: 'CRIADO',
          urgente: false,
          itens: [],
          grupoPedido: null,
        },
        viewMode: false,
        isConclued: false,
      });
    }
  };

  carregarPedidoParaFormulario = (id, duplicando = false) => {
    this.props.loading(true);

    pedidosService.doGet(id).then(
      (response) => {
        let pedido = this.normalizarGrupoPedidoLegado(response.data);

        const finalizarCarregamento = () => {
          if (duplicando) {
            pedido = this.montarPedidoDuplicado(pedido);
            this.setState({
              entity: pedido,
              viewMode: false,
              isConclued: false,
            });
            this.props.loading(false);
            return;
          }

          Promise.all([
            pedidosService.validaEdicao(id),
            pedidosService.validaConclusao(id),
          ]).then(
            (responseViewMode) => {
              this.setState(
                {
                  viewMode: responseViewMode[0].data,
                  isConclued: responseViewMode[1].data,
                },
                () => {
                  this.setState({ entity: pedido }, () => {
                    this.props.loading(false);
                  });
                },
              );
            },
            (errorViewMode) => {
              console.log(errorViewMode);
              this.props.loading(false);
            },
          );
        };

        if (pedido.itens && pedido.itens.length > 0) {
          const produtos = _.uniqBy(pedido.itens, 'produto.codigoProduto');
          const itens = _.map(produtos, (itemProduto) => {
            const produto = _.cloneDeep(itemProduto.produto || {});

            produto.id =
              produto.id ||
              itemProduto.idProduto ||
              produto.codigoProduto ||
              produto.codigoOmni;

            produto.label = `${produto.codigoProduto ||
              ''} - ${produto.descricao || ''} | ${produto.unidadeMedida ||
              produto.unidade ||
              ''}`;

            const itensDoProduto = _.filter(pedido.itens, [
              'produto.codigoProduto',
              produto.codigoProduto,
            ]);
            const indicesOriginais = itensDoProduto.map((item) =>
              pedido.itens.indexOf(item),
            );

            produto.estoque = itensDoProduto.map((item) => {
              return {
                lote: item.observacoes,
                observacoes: item.observacoes,
                quantidade: item.quantidade,
                dataDeValidade: item.dataValidade,
                itemIndexOrigem: pedido.itens.indexOf(item),
              };
            });

            return {
              produto,
              itemIndexOrigem:
                indicesOriginais.length === 1 ? indicesOriginais[0] : null,
            };
          });

          // A visualizacao usa os lotes ja vinculados ao pedido. A consulta
          // de saldo fica para a selecao/troca de produto, sem bloquear a tela.
          pedido.itens = itens;
          finalizarCarregamento();
        } else {
          finalizarCarregamento();
        }
      },
      (error) => {
        console.log(error);
        this.props.loading(false);
      },
    );
  };

  montarPedidoDuplicado = (pedidoOriginal) => {
    const pedido = _.cloneDeep(pedidoOriginal || {});

    delete pedido.id;
    delete pedido._links;
    delete pedido.numero;
    delete pedido.numeroPedido;
    delete pedido.numeroPedidoTemporario;
    delete pedido.numeroOmie;
    delete pedido.status;
    delete pedido.statusAlcis;
    delete pedido.createdAt;
    delete pedido.updatedAt;
    delete pedido.ultimaAtualizacao;
    delete pedido.usuarioId;
    delete pedido.usuarioAprovacaoId;
    delete pedido.criadoPorNome;
    delete pedido.aprovadoPorNome;

    pedido.statusInterno = 'CRIADO';
    pedido.concluido = false;
    pedido.numeroNotaFiscal = null;

    if (!pedido.tipoPedido) {
      pedido.tipoPedido = 'AVULSO';
    }

    const clienteTemPA =
      pedido &&
      pedido.cliente &&
      pedido.cliente.possuiPontoAtendimento === true;

    if (clienteTemPA) {
      pedido.grupoPedido = pedido.grupoPedido || null;
    } else {
      delete pedido.grupoPedido;
    }
    pedido.grupoPedido = pedido.grupoPedido || null;

    return pedido;
  };

  changeProduto = (
    value,
    setFieldValue,
    name,
    index,
    clienteSelecionado,
  ) => {
    if (value) {
      this.props.loading(true);
      pedidosService
        .findEstoque(value, isSudo() ? clienteSelecionado : null)
        .then(
          (r) => {
            if (r) {
              let estoque = r.data;
              if (estoque.length >= 1) {
                setFieldValue(name, value);
                setFieldValue('produtoEstoque', value);
                setFieldValue('estoque', estoque);
                setFieldValue('index', index);
                this.props.loading(false);
              } else {
                this.props.loading(false);
                this.props.info({
                  message: 'Não existe saldo em estoque deste produto!',
                });
              }
            }
          },
          (error) => {
            this.props.loading(false);
            this.props.info({
              message: 'Não existe saldo em estoque deste produto!',
            });
          },
        );
    } else {
      setFieldValue(name, value);
      setFieldValue('produtoEstoque', null);
      setFieldValue('index', null);
    }
  };

  getQuantidadeAjusteOmie = (itemIndex, quantidadeAtual) => {
    const valor = this.state.quantidadesAjusteOmie[itemIndex];
    return valor === undefined ? quantidadeAtual : valor;
  };

  alterarQuantidadeAjusteOmie = (itemIndex, value) => {
    this.setState((state) => ({
      quantidadesAjusteOmie: {
        ...state.quantidadesAjusteOmie,
        [itemIndex]: value,
      },
    }));
  };

  ajustarQuantidadeItemOmie = (pedido, item, quantidadeAtual) => {
    const itemIndex = item && item.itemIndexOrigem;
    const valorInformado = this.getQuantidadeAjusteOmie(
      itemIndex,
      quantidadeAtual,
    );
    const quantidade = Number(valorInformado);
    const codigoProduto = _.get(item, 'produto.codigoProduto', '');

    if (itemIndex === null || itemIndex === undefined) {
      this.props.error({
        message:
          'Não foi possível identificar a linha original deste item. Recarregue o pedido.',
      });
      return;
    }

    if (
      valorInformado === '' ||
      valorInformado === null ||
      valorInformado === undefined ||
      !Number.isFinite(quantidade) ||
      quantidade < 0
    ) {
      this.props.error({ message: 'Informe uma quantidade maior ou igual a zero.' });
      return;
    }

    const excluir = quantidade === 0;
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="custom-confirm-alert">
          <h2>Confirmar ajuste no Omie</h2>
          <p>
            {excluir
              ? `O item ${codigoProduto} será excluído do Omie e do pedido local.`
              : `A quantidade do item ${codigoProduto} será alterada para ${quantidade}.`}
          </p>
          <p>Essa operação será registrada para o usuário SUDO.</p>
          <div className="d-flex justify-content-around mt-4">
            <button
              className="btn btn-secondary btn30 white"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              className="btn btn-danger btn30"
              onClick={() => {
                onClose();
                this.executarAjusteQuantidadeItemOmie(
                  pedido,
                  item,
                  itemIndex,
                  quantidadeAtual,
                  quantidade,
                );
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      ),
    });
  };

  executarAjusteQuantidadeItemOmie = (
    pedido,
    item,
    itemIndex,
    quantidadeAtual,
    quantidade,
  ) => {
    const pedidoId = pedido && (pedido.id || pedido._id);
    const codigoProduto = _.get(item, 'produto.codigoProduto', '');

    if (!pedidoId) {
      this.props.error({ message: 'Não foi possível identificar o pedido.' });
      return;
    }

    this.setState((state) => ({
      salvandoAjusteOmie: {
        ...state.salvandoAjusteOmie,
        [itemIndex]: true,
      },
    }));

    pedidosService
      .ajustarItemQuantidade(pedidoId, {
        itemIndex,
        codigoProduto,
        quantidadeAtual: Number(quantidadeAtual),
        quantidade,
      })
      .then(() => {
        this.props.success({
          message:
            quantidade === 0
              ? 'Item excluído do Omie e do pedido local.'
              : 'Quantidade do item atualizada no Omie e no pedido local.',
        });
        this.setState({
          quantidadesAjusteOmie: {},
          salvandoAjusteOmie: {},
        });
        this.carregarPedidoParaFormulario(pedidoId, false);
      })
      .catch((error) => {
        let message = _.get(error, 'response.data');
        if (message && typeof message !== 'string') {
          message =
            _.get(message, 'message') ||
            _.get(message, 'error') ||
            'Não foi possível ajustar o item no Omie.';
        }
        this.props.error({
          message: message || 'Não foi possível ajustar o item no Omie.',
        });
        this.setState((state) => ({
          salvandoAjusteOmie: {
            ...state.salvandoAjusteOmie,
            [itemIndex]: false,
          },
        }));
      });
  };

  renderControleAjusteItemOmie = (pedido, item, quantidadeAtual) => {
    const linhas =
      item && item.itemIndexOrigem !== null && item.itemIndexOrigem !== undefined
        ? [
            {
              itemIndexOrigem: item.itemIndexOrigem,
              quantidade: quantidadeAtual,
              identificacao: '',
            },
          ]
        : _.get(item, 'produto.estoque', [])
            .filter(
              (estoque) =>
                estoque &&
                estoque.itemIndexOrigem !== undefined &&
                estoque.itemIndexOrigem !== null,
            )
            .map((estoque) => ({
              itemIndexOrigem: estoque.itemIndexOrigem,
              quantidade: estoque.quantidade,
              identificacao: estoque.observacoes || estoque.lote || 'Linha',
            }));

    if (linhas.length === 0) {
      return null;
    }

    return (
      <div className="form-group col-12 border rounded p-2 mt-2">
        <strong>Ajuste SUDO no Omie</strong>
        <small className="d-block text-muted mb-2">
          Quantidade zero exclui o item no Omie e no pedido local.
        </small>
        {linhas.length > 1 && (
          <small className="d-block text-muted mb-2">
            Este produto possui mais de uma linha ou lote. Ajuste a linha
            desejada:
          </small>
        )}
        {linhas.map((linha) => {
          const itemIndex = linha.itemIndexOrigem;
          const salvando = Boolean(
            this.state.salvandoAjusteOmie[itemIndex],
          );
          const valorAtual = linha.quantidade;

          return (
            <div
              className="d-flex align-items-center mb-2"
              key={itemIndex}
            >
              <span className="mr-2">
                {linha.identificacao || 'Quantidade atual'}:{' '}
                {valorAtual}
              </span>
              <input
                type="number"
                min="0"
                step="any"
                className="form-control mr-2"
                style={{ maxWidth: '130px' }}
                value={this.getQuantidadeAjusteOmie(itemIndex, valorAtual)}
                disabled={salvando}
                onChange={(e) =>
                  this.alterarQuantidadeAjusteOmie(
                    itemIndex,
                    e.target.value,
                  )
                }
              />
              <button
                type="button"
                className="btn btn-warning btn30"
                disabled={salvando}
                onClick={() =>
                  this.ajustarQuantidadeItemOmie(
                    pedido,
                    {
                      produto: item.produto,
                      itemIndexOrigem: itemIndex,
                    },
                    valorAtual,
                  )
                }
              >
                {salvando ? 'Salvando...' : 'Aplicar no Omie'}
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  showError = (messageError) => {
    this.props.error({ message: messageError });
    return '';
  };

  showInfo = (messageInfo) => {
    this.props.info({ message: messageInfo });
    return '';
  };

  clearError = () => {
    this.props.clear();
    return '';
  };

  render() {
    const { entity } = this.state;

    const isFinalizado =
      entity &&
      (entity.statusInterno === 'APROVADO' ||
        entity.statusInterno === 'RECUSADO' ||
        entity.status === 'APROVADO' ||
        entity.status === 'RECUSADO');

    let _this = this;

    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Pedidos" subTitle=" " canBack={true} />
        <Formik
          validationSchema={
            this.state.viewMode ? {} : getPedidoValidationSchema()
          }
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={this.handleSubmitPedido}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {
            const isSudoOrAdminBio = isSudo() || isAdminBio();
            const clienteSelecionado = values.cliente;
            const clienteTemPA =
              clienteSelecionado && clienteSelecionado.possuiPontoAtendimento;
            const paSelecionado = values.pontoAtendimentoId;
            const tipoPedidoEmMapa = values.tipoPedido === 'MAPA';
            const isPedidoTemporario =
              typeof values.numeroPedido === 'string' &&
              values.numeroPedido.indexOf('TMP-') === 0;
            const podeAlterarStatus =
              (isSudo() ||
                ((isAdmin() || isAprovador()) && hasClienteComPA())) &&
              (this.state.viewMode || isPedidoTemporario) &&
              !isFinalizado;

            const opcoesGrupoPedido = tipoPedidoEmMapa
              ? objectsConstants.GRUPO_PEDIDO_MAPA
              : objectsConstants.GRUPO_PEDIDO_AVULSO;
            const camposDesabilitados = (() => {
              if (isFinalizado) return true;
              if (this.state.viewMode) return true;
              if (isSudoOrAdminBio) {
                if (!clienteSelecionado) return true;
                if (clienteTemPA && !paSelecionado) return true;
              }
              if (isAdmin()) {
                if (clienteTemPA && !paSelecionado) return true;
              }
              return false;
            })();

            const ocultarLoteValidadeProduto = clienteTemPA
              ? true
              : _.get(values, 'cliente.ocultarLoteValidadeProduto', false);

            const podeEditarProdutosNaAprovacao =
              this.state.viewMode === true &&
              hasClienteComPA() &&
              values &&
              !isFinalizado &&
              (isSudo() || isAdmin() || isAprovador() || isAdminBio());

            const podeAjustarItemOmie =
              isSudo() &&
              values &&
              values.id &&
              values.numeroOmie &&
              !isPedidoTemporario;

            return (
              <form onSubmit={handleSubmit} noValidate>
                <div className="flex-column p-5">
                  <Toast />

                  {Array.isArray(values.estoque) && values.estoque.length > 0 && (
                    <CadastroPedidoModal
                      estoque={values.estoque}
                      index={_this.state.index}
                      produto={_.get(values, `itens[${values.index}].produto`)}
                      cliente={isSudo() ? values.cliente : null}
                      possuiPontoAtendimento={!!clienteTemPA}
                      podeAjustarItemIntegrado={isSudo()}
                      isModalVisible={values.produtoEstoque}
                      ocultarLoteValidadeProduto={ocultarLoteValidadeProduto}
                      setFieldValue={setFieldValue}
                      info={this.props.info}
                      atualizarEstoque={(produto) => {
                        if (!produto) {
                          return Promise.resolve();
                        }

                        return pedidosService
                          .findEstoque(
                            produto,
                            isSudo() ? values.cliente : null,
                          )
                          .then(
                            (response) => {
                              setFieldValue(
                                'estoque',
                                (response && response.data) || [],
                              );
                              return response;
                            },
                          );
                      }}
                      selectEstoque={(produtos) => {
                        setFieldValue(
                          `itens[${values.index}].produto.estoque`,
                          produtos,
                        );
                        setFieldValue(`estoque`, []);
                        setFieldValue(`produtoEstoque`, null);
                        setFieldValue(`index`, null);
                      }}
                      onCancel={() => {
                        if (
                          !_.get(
                            values,
                            `itens[${values.index}].produto.estoque`,
                          )
                        ) {
                          setFieldValue(`itens[${values.index}].produto`, null);
                        }
                        setFieldValue(`estoque`, []);
                        setFieldValue(`produtoEstoque`, null);
                        setFieldValue(`index`, null);
                      }}
                    />
                  )}

                  {!_.isEmpty(errors) &&
                    this.showError(objectsConstants.messageCampoObrigatorio)}

                  <div className="cardSeculus d-flex flex-column mb-0">
                    <div className="topoCard d-flex flex-column flex-sm-row">
                      <h3 className="flex-grow-1">Pedidos</h3>
                    </div>

                    <div className="form-row">
                      {values.id && <AuditLogModal pedidoId={values.id} />}

                      {(isSudo() || isAdminBio()) && (
                        <div className="form-group col-6 col-lg-6">
                          {!this.state.viewMode && (
                            <FormSelectInput
                              name="cliente"
                              id={'cliente'}
                              label="Cliente"
                              placeholder="Selecione o cliente"
                              valueKey="id"
                              labelKey="label"
                              noSize={true}
                              required={false}
                              returnFullObject={true}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              service={clienteService.findAll}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                              }}
                              value={values.cliente}
                              disabled={isFinalizado}
                            />
                          )}
                        </div>
                      )}

                      {values.cliente &&
                        (isSudo() ||
                          isAdmin() ||
                          isAprovador() ||
                          isSolicitante() ||
                          isAdminBio()) &&
                        !!values.cliente.possuiPontoAtendimento && (
                          <div className="form-group col-md-6">
                            <FormSelectInput
                              key={values.cliente.codigoCliente}
                              name="pontoAtendimentoId"
                              id="pontoAtendimentoId"
                              label="Ponto de Atendimento"
                              placeholder="Selecione o PA"
                              valueKey="id"
                              labelKey="nome"
                              required={true}
                              returnFullObject={false}
                              parent={values.cliente}
                              service={pontoAtendimentoService.findAllByCliente}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                              }}
                              value={values.pontoAtendimentoId}
                              messageValidate={errors.pontoAtendimentoId}
                              disabled={isFinalizado}
                            />
                          </div>
                        )}

                      {podeAlterarStatus && (
                          <div className="form-group col-md-6">
                            <SelectInput
                              name="statusInterno"
                              id="statusInterno"
                              label="Status"
                              placeholder="Selecione o novo status"
                              valueKey="value"
                              labelKey="label"
                              noSize={true}
                              returnFullObject={false}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
                              messageValidate={errors.statusInterno}
                              disabled={isFinalizado}
                              value={values.statusInterno}
                              className={`select-status ${values.statusInterno &&
                                values.statusInterno.toLowerCase()}`}
                              onChange={(name, value) => {
                                const statusAnterior = values.statusInterno;
                                const statusNovo = value;
                                const finalizando =
                                  statusAnterior !== 'APROVADO' &&
                                  statusAnterior !== 'RECUSADO' &&
                                  (statusNovo === 'APROVADO' ||
                                    statusNovo === 'RECUSADO');

                                if (finalizando) {
                                  confirmAlert({
                                    customUI: ({ onClose }) => (
                                      <div className="custom-confirm-alert">
                                        <h2>Confirmação</h2>
                                        <p>
                                          Ao aprovar ou recusar, o pedido não
                                          poderá mais ser alterado. Deseja
                                          continuar?
                                        </p>
                                        <div className="d-flex justify-content-around mt-4">
                                          <button
                                            className="btn btn-secondary btn30 white"
                                            onClick={onClose}
                                          >
                                            Cancelar
                                          </button>
                                          <button
                                            className="btn btn-danger btn30"
                                            onClick={() => {
                                              setFieldValue(name, value);
                                              onClose();
                                            }}
                                          >
                                            Confirmar
                                          </button>
                                        </div>
                                      </div>
                                    ),
                                  });
                                } else {
                                  setFieldValue(name, value);
                                }
                              }}
                            />
                          </div>
                        )}

                      {/* ======= CABEÇALHO (voltou do antigo) ======= */}

                      {/* dados que pertencem a clientes com PA */}
                      {values.cliente &&
                        !!values.cliente.possuiPontoAtendimento && (
                          <div className="row col-12">
                            <div className="form-group col-3 col-lg-3">
                              {!this.state.viewMode && (
                                <SelectInput
                                  name="tipoPedido"
                                  id="tipoPedido"
                                  label="Tipo de pedido"
                                  placeholder="Selecione o Tipo de pedido"
                                  valueKey="value"
                                  labelKey="label"
                                  required={true}
                                  returnFullObject={false}
                                  defaultValue={values.tipoPedido}
                                  options={objectsConstants.TIPO_PEDIDO}
                                  onChange={(name, value) => {
                                    setFieldValue(name, value);

                                    if (value === 'MAPA') {
                                      const grupoAtualValido = (
                                        objectsConstants.GRUPO_PEDIDO_MAPA || []
                                      ).some(
                                        (item) =>
                                          item.value === values.grupoPedido,
                                      );

                                      if (!grupoAtualValido) {
                                        setFieldValue(
                                          'grupoPedido',
                                          'ALMOXARIFADO',
                                        );
                                      }
                                    } else {
                                      const grupoAtualValido = (
                                        objectsConstants.GRUPO_PEDIDO_AVULSO ||
                                        []
                                      ).some(
                                        (item) =>
                                          item.value === values.grupoPedido,
                                      );

                                      if (!grupoAtualValido) {
                                        setFieldValue('grupoPedido', null);
                                      }
                                    }
                                  }}
                                  value={values.tipoPedido}
                                  disabled={camposDesabilitados || isFinalizado}
                                  messageValidate={errors.tipoPedido}
                                />
                              )}
                              {this.state.viewMode && (
                                <div>
                                  <label className="label-nowrap">
                                    Tipo de pedido:
                                  </label>
                                  <div>{values.tipoPedido}</div>
                                </div>
                              )}
                            </div>
                            <div className="form-group col-3 col-lg-3">
                              {!this.state.viewMode && (
                                <SelectInput
                                  name="grupoPedido"
                                  id="grupoPedido"
                                  label="Grupo do Pedido"
                                  placeholder="Selecione o grupo"
                                  valueKey="value"
                                  labelKey="label"
                                  required={true}
                                  returnFullObject={false}
                                  isMulti={false}
                                  searchable={false}
                                  allowSelectAll={false}
                                  options={opcoesGrupoPedido}
                                  onChange={(name, value) => {
                                    setFieldValue(name, value);
                                  }}
                                  value={values.grupoPedido}
                                  disabled={camposDesabilitados || isFinalizado}
                                  messageValidate={errors.grupoPedido}
                                />
                              )}

                              {this.state.viewMode && (
                                <div>
                                  <label className="label-nowrap">
                                    Grupo do pedido:
                                  </label>
                                  <div>
                                    {_.get(
                                      (opcoesGrupoPedido || []).find(
                                        (item) =>
                                          item.value ===
                                          (values.grupoPedido ||
                                            (tipoPedidoEmMapa
                                              ? 'ALMOXARIFADO'
                                              : 'DOMICILIAR')),
                                      ),
                                      'label',
                                      values.grupoPedido ||
                                        (tipoPedidoEmMapa
                                          ? 'ALMOXARIFADO'
                                          : 'DOMICILIAR'),
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            {(values.grupoPedido === 'JUDICIAL' ||
                              values.grupoPedido === 'DOMICILIAR') && (
                              <React.Fragment>
                                <div className="form-group col-3 col-lg-5">
                                  {!this.state.viewMode && (
                                    <FormInput
                                      name="nomePaciente"
                                      id={'nomePaciente'}
                                      label="Nome do paciente"
                                      placeholder="Nome do paciente"
                                      noSize={true}
                                      required={true}
                                      returnFullObject={true}
                                      isMulti={false}
                                      searchable={false}
                                      allowSelectAll={false}
                                      onChange={setFieldValue}
                                      value={values.nomePaciente}
                                      disabled={
                                        camposDesabilitados || isFinalizado
                                      }
                                      messageValidate={errors.nomePaciente}
                                    />
                                  )}
                                  {this.state.viewMode && (
                                    <div>
                                      <label className="label-nowrap">
                                        Nome do paciente:
                                      </label>
                                      <div>{values.nomePaciente}</div>
                                    </div>
                                  )}
                                </div>

                                <div className="form-group col-3 col-lg-4">
                                  {!this.state.viewMode && (
                                    <CpfInput
                                      name="cpfPaciente"
                                      id={'cpfPaciente'}
                                      label="CPF do paciente"
                                      placeholder="CPF do paciente"
                                      noSize={true}
                                      returnFullObject={true}
                                      isMulti={false}
                                      searchable={false}
                                      allowSelectAll={false}
                                      onChange={setFieldValue}
                                      value={values.cpfPaciente}
                                      disabled={
                                        camposDesabilitados || isFinalizado
                                      }
                                      erroMensagem={errors.cpfPaciente}
                                      required={true}
                                    />
                                  )}
                                  {this.state.viewMode && (
                                    <div>
                                      <label className="label-nowrap">
                                        CPF do paciente:
                                      </label>
                                      <div>{values.cpfPaciente}</div>
                                    </div>
                                  )}
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        )}
                      {/* Fim dados pertencem clientes com PA */}

                      <div className="row col-12">
                        <div className="form-group col-3 col-lg-3">
                          {!this.state.viewMode && (
                            <FormInput
                              name="numeroPedidoCliente"
                              id={'numeroPedidoCliente'}
                              label="Número do pedido (Cliente)"
                              placeholder="Número pedido"
                              noSize={true}
                              required={false}
                              returnFullObject={true}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              onChange={setFieldValue}
                              value={values.numeroPedidoCliente}
                              disabled={camposDesabilitados || isFinalizado}
                            />
                          )}
                          {this.state.viewMode && (
                            <div>
                              <label className="label-nowrap">
                                Número do pedido(Cliente):
                              </label>
                              <div>{values.numeroPedidoCliente}</div>
                            </div>
                          )}
                        </div>

                        <div className="form-group col-3 col-lg-3">
                          {!this.state.viewMode && (
                            <FormInput
                              name="transportadora"
                              id={'transportadora'}
                              label="Transportadora"
                              placeholder="Transportadora"
                              noSize={true}
                              required={false}
                              returnFullObject={true}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              onChange={setFieldValue}
                              value={values.transportadora}
                              disabled={camposDesabilitados || isFinalizado}
                            />
                          )}
                          {this.state.viewMode && (
                            <div>
                              <label className="label-nowrap">
                                Transportadora:
                              </label>
                              <div>{values.transportadora}</div>
                            </div>
                          )}
                        </div>

                        {(!values.cliente ||
                          !values.cliente.possuiPontoAtendimento) && (
                          <div className="form-group col-3 col-lg-3">
                            {!this.state.viewMode && (
                              <DateTimePicker
                                name="dataHoraColeta"
                                id={'dataHoraColeta'}
                                label="Data e Hora da Coleta"
                                placeholder="Data e Hora da Coleta"
                                erroMensagem={errors.dataHoraColeta}
                                onChange={setFieldValue}
                                value={values.dataHoraColeta}
                                disabled={camposDesabilitados || isFinalizado}
                                required={true}
                              />
                            )}
                            {this.state.viewMode && (
                              <div>
                                <label className="label-nowrap">
                                  Data e Hora da Coleta:
                                </label>
                                <div>
                                  {values.dataHoraColeta
                                    ? moment(values.dataHoraColeta).format(
                                        'DD/MM/YYYY HH:mm',
                                      )
                                    : ''}
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="form-group col-1 col-lg-1 text-center">
                          <div>
                            <label className="label-nowrap">Urgente:</label>
                            <div>
                              {!this.state.viewMode && (
                                <Switch
                                  onChange={(value) =>
                                    setFieldValue('urgente', value)
                                  }
                                  checked={values.urgente}
                                  onColor={'#0080ff'}
                                  offColor={'#d9d9d9'}
                                  height={30}
                                  width={60}
                                  handleDiameter={28}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  activeBoxShadow={'none'}
                                  disabled={camposDesabilitados || isFinalizado}
                                />
                              )}
                              {this.state.viewMode &&
                                values.cliente &&
                                (values.urgente ? 'Sim' : 'Não')}
                            </div>
                          </div>
                        </div>

                        {(!values.cliente ||
                          !values.cliente.possuiPontoAtendimento) && (
                          <div className="form-group col-2 col-lg-2 text-center">
                            <div>
                              <label className="label-nowrap">
                                Cadastro concluido:
                              </label>
                              <div>
                                {!this.state.isConclued && (
                                  <Switch
                                    onChange={(value) =>
                                      setFieldValue('concluido', value)
                                    }
                                    checked={values.concluido}
                                    onColor={'#0080ff'}
                                    offColor={'#d9d9d9'}
                                    height={30}
                                    width={60}
                                    handleDiameter={28}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    activeBoxShadow={'none'}
                                  />
                                )}
                                {this.state.isConclued &&
                                  values.cliente &&
                                  (values.concluido ? 'Sim' : 'Não')}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {(!values.cliente ||
                        !values.cliente.possuiPontoAtendimento) && (
                        <React.Fragment>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="nf"
                              id="NF"
                              label="NF"
                              readOnly={this.state.isConclued || isFinalizado}
                              emptyLabel={'Adicionar NF'}
                              onChange={setFieldValue}
                              value={values.nf}
                              fileItem={values.nf}
                            />
                          </div>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="pv"
                              id="PV"
                              label="PV"
                              readOnly={this.state.isConclued || isFinalizado}
                              emptyLabel={'Adicionar PV'}
                              onChange={setFieldValue}
                              value={values.pv}
                              fileItem={values.pv}
                            />
                          </div>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="tag"
                              id="TAG"
                              label="TAG"
                              readOnly={this.state.isConclued || isFinalizado}
                              emptyLabel={'Adicionar TAG'}
                              onChange={setFieldValue}
                              value={values.tag}
                              fileItem={values.tag}
                            />
                          </div>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="cartaDeCorrecao"
                              id="CartaDeCorrecao"
                              label="Carta de Correção"
                              readOnly={this.state.isConclued || isFinalizado}
                              emptyLabel={'Adicionar Carta de Correção'}
                              onChange={setFieldValue}
                              value={values.cartaDeCorrecao}
                              fileItem={values.cartaDeCorrecao}
                            />
                          </div>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="guiaDifal"
                              id="GuiaDifal"
                              label="Guia Difal"
                              readOnly={this.state.isConclued || isFinalizado}
                              emptyLabel={'Adicionar Guia Difal'}
                              onChange={setFieldValue}
                              value={values.guiaDifal}
                              fileItem={values.guiaDifal}
                            />
                          </div>
                          <div className="form-group col-4 col-lg-4">
                            <FileInput
                              name="comprovanteDifal"
                              readOnly={this.state.isConclued || isFinalizado}
                              id="ComprovanteDifal"
                              label="Comprovante Difal"
                              emptyLabel={'Adicionar Comprovante Difal'}
                              onChange={setFieldValue}
                              value={values.comprovanteDifal}
                              fileItem={values.comprovanteDifal}
                            />
                          </div>
                        </React.Fragment>
                      )}

                      <div className="form-group col-12 col-lg-12">
                        {!this.state.viewMode && (
                          <FormInput
                            name="observacoes"
                            id={'observacoes'}
                            label="Observações"
                            placeholder="Observações"
                            noSize={true}
                            required={false}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            onChange={setFieldValue}
                            value={values.observacoes}
                            disabled={camposDesabilitados || isFinalizado}
                          />
                        )}
                        {this.state.viewMode && (
                          <div>
                            <label className="label-nowrap">Observações:</label>
                            <div>{values.observacoes}</div>
                          </div>
                        )}
                      </div>

                      {/* ======= PRODUTOS (regra nova mantida) ======= */}
                      <div className="col-12">
                        <p>
                          Adicione abaixo os produtos para solicitar o pedido:
                        </p>

                        {((!this.state.viewMode && !isFinalizado) ||
                          podeEditarProdutosNaAprovacao) && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              let newItens = _.cloneDeep(values.itens);
                              if (!newItens) newItens = [];
                              newItens.push({});
                              setFieldValue('itens', newItens);
                            }}
                          >
                            Adicionar Produto ao pedido
                          </button>
                        )}
                      </div>

                      {values.itens &&
                        values.itens.map((item, index) => {
                          const podeEditarEsteItem =
                            podeEditarProdutosNaAprovacao &&
                            item &&
                            item.produto;
                          const produto =
                            item && item.produto ? item.produto : {};
                          const codigoProduto =
                            produto.codigoProduto ||
                            (item && item.codigoProduto) ||
                            '';
                          const descricaoProduto =
                            produto.descricao ||
                            produto.label ||
                            (item && item.descricaoProduto) ||
                            '';
                          const quantidadeItem =
                            item &&
                            item.quantidade !== undefined &&
                            item.quantidade !== null
                              ? item.quantidade
                              : produto.estoque
                                ? produto.estoque
                                    .filter((e) => e && e.quantidade)
                                    .reduce(
                                      (total, e) =>
                                        total + Number(e.quantidade),
                                      0,
                                    )
                                : '';

                          return (
                            <div
                              className="form-group col-12 col-lg-12 row"
                              key={index}
                            >
                              <hr className={'col-12'} />

                              {/* Em aprovação: não troca produto existente; só permite "Editar quantidade" */}
                              {(this.state.viewMode || isFinalizado) &&
                                item &&
                                item.produto && (
                                <div className="form-group col-8">
                                  <p>
                                    <strong>{codigoProduto}</strong>
                                    {descricaoProduto
                                      ? ` - ${descricaoProduto}`
                                      : ''}
                                  </p>

                                  {podeEditarEsteItem && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        this.changeProduto(
                                          item.produto,
                                          setFieldValue,
                                          `itens[${index}].produto`,
                                          index,
                                          values.cliente,
                                        );
                                      }}
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        color: '#007bff',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      Editar quantidade
                                    </button>
                                  )}
                                </div>
                              )}

                              {/* Novo item (em criação OU em aprovação): selector */}
                              {((!this.state.viewMode && !isFinalizado) ||
                                (podeEditarProdutosNaAprovacao &&
                                  (!item || !item.produto))) && (
                                <div className="form-group col-6">
                                  <FormSelectInput
                                    name={`itens[${index}].produto`}
                                    id={'produto'}
                                    label="Código ou descrição do Produto"
                                    placeholder="Selecione o produto"
                                    valueKey="id"
                                    labelKey="label"
                                    parent={values.cliente}
                                    disabled={isFinalizado || !values.cliente}
                                    noSize={true}
                                    required={true}
                                    returnFullObject={true}
                                    isMulti={false}
                                    searchable={true}
                                    minSearchLength={3}
                                    debounceMs={500}
                                    allowSelectAll={false}
                                    onFetchData={produtoService.buscarPorCliente}
                                    onChange={(name, value) => {
                                      this.changeProduto(
                                        value,
                                        setFieldValue,
                                        name,
                                        index,
                                        values.cliente,
                                      );
                                    }}
                                    value={item ? item.produto : null}
                                    erroMensagem={_.get(
                                      errors,
                                      `itens[${index}].produto.id`,
                                    )}
                                  />
                                </div>
                              )}

                              {item &&
                                item.produto &&
                                ocultarLoteValidadeProduto && (
                                  <div className="col-12 col-md-3 d-flex align-items-center">
                                    <b>
                                      Quantidade:{' '}
                                      {quantidadeItem}
                                    </b>
                                  </div>
                                )}

                              {podeAjustarItemOmie &&
                                item &&
                                item.produto &&
                                this.renderControleAjusteItemOmie(
                                  values,
                                  item,
                                  quantidadeItem,
                                )}

                              <div className="form-group col-2 d-flex align-items-center">
                                {!(camposDesabilitados || isFinalizado) && (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      let newItens = _.cloneDeep(values.itens);
                                      newItens.splice(index, 1);
                                      setFieldValue('itens', newItens);
                                    }}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      padding: 0,
                                      color: '#007bff',
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    remover
                                  </button>
                                )}
                              </div>

                              {item &&
                                item.produto &&
                                item.produto.estoque &&
                                !ocultarLoteValidadeProduto && (
                                  <table className={'col-12 table'}>
                                    <tbody>
                                      <tr>
                                        <th>Lote</th>
                                        <th>Data de Validade</th>
                                        <th>Quantidade</th>
                                      </tr>
                                      {item.produto.estoque.map(
                                        (estoque, indexEstoque) => {
                                          if (estoque && estoque.quantidade) {
                                            return (
                                              <tr key={indexEstoque}>
                                                <td>
                                                  {_.get(
                                                    estoque,
                                                    'observacoes',
                                                    _.get(estoque, 'lote'),
                                                  )}
                                                </td>
                                                <td>
                                                  {estoque.dataDeValidade
                                                    ? moment(
                                                        estoque.dataDeValidade,
                                                      ).format('DD/MM/YYYY')
                                                    : ''}
                                                </td>
                                                <td>{estoque.quantidade}</td>
                                              </tr>
                                            );
                                          }
                                          return null;
                                        },
                                      )}
                                    </tbody>
                                  </table>
                                )}
                            </div>
                          );
                        })}
                    </div>

                    {(!this.state.viewMode || !this.state.isConclued) && (
                      <div className="d-flex flex-row flex-sm-row ">
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="button"
                            className="btn btn-secondary btn30 white"
                            disabled={isSubmitting}
                            onClick={() => this.props.history.goBack()}
                          >
                            Cancelar
                          </button>
                        </div>
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="submit"
                            disabled={
                              isSubmitting ||
                              !values.itens ||
                              values.itens.length === 0 ||
                              isFinalizado
                            }
                            className="btn btn-secondary btn30 green"
                          >
                            Enviar pedido
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return { user };
}

const mapDispatch = ({
  alert: { success, error, clear, info },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  info: (msg) => info(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true },
)(PedidoEdit);
